import React from 'react';

export interface StepCardProps {
  /** When false, no inner padding — useful for media that wants to bleed edge-to-edge. */
  padded?: boolean;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

/** Workspace content wrapper used by every step. Does NOT include an in-card
 *  header — the toolbar already shows the step kicker + blurb. Repeating it
 *  inside the card pushes the primary CTA below the fold. */
export const StepCard: React.FC<StepCardProps> = ({
  padded = true,
  className,
  style,
  children,
}) => {
  return (
    <div
      className={className}
      style={{
        position: 'relative',
        overflow: 'hidden',
        background: 'var(--hj-surface-1)',
        border: '1px solid var(--hj-hairline)',
        borderRadius: 'var(--hj-r-md)',
        padding: padded ? '28px 32px 32px' : 0,
        color: 'var(--hj-ink)',
        ...style,
      }}
    >
      {children}
    </div>
  );
};
